import { useRef } from "react";

let nextUniqueId = 0;

export const masterPrefix = "fbds";

export const defaultElementPrefix = "element";

/**
 * Utility function to get unique ids to be used for UI elements.
 * If `id` is passed uses that as is.
 *
 * @param id      Value to use to create a persistent id value.
 * @param prefix  Prefix to use to construct a generated id value.
 */
export const getElementId = (id?: string, prefix: string = defaultElementPrefix) => {
  return id ?? `${masterPrefix}-${prefix}-${++nextUniqueId}`;
};

/**
 * This hook create unique id values to be used with various form field components - Input, Select etc.
 *
 * @todo [BDS-532] See how this can be made SSR safe - check out : https://www.npmjs.com/package/react-uid
 * @todo [BDS-532] call getElementId() only once per unique useRef()
 *
 * @param id      Value to use to create a persistent id value.
 * @param prefix  Prefix to use to construct a generated id value.
 */
export const useElementId = (id?: string, prefix?: string) => {
  const nextId = getElementId(id, prefix);
  const persistedElementId = useRef(nextId);
  return persistedElementId.current;
};
